import { ChatWidgetText, SubscriptionWidget } from "../../../Helper/ChatWidget";
import { ArrowUpRightIcon } from "../ChatWidgetIcons";
import { Card, Eyebrow, LinkFoot, Meter, Pill } from "../ChatWidgetPrimitives";
import "./SubscriptionCard.scss";

/** 07 Subscription: plan, price, usage meters and renewal. */
export const SubscriptionCard = ({
  widget,
  text,
}: {
  widget: SubscriptionWidget;
  text: ChatWidgetText;
}) => {
  const dateRow = widget.endsOn
    ? { label: text("widgetEnds"), value: widget.endsOn }
    : widget.renewsOn
      ? { label: text("widgetRenews"), value: widget.renewsOn }
      : undefined;
  return (
    <Card className="cw-sub" label={widget.title ?? text("widgetSubscription")}>
      <div className="cw-pad">
        <div className="cw-row">
          <Eyebrow>{text("widgetSubscription")}</Eyebrow>
          <Pill status={widget.status} />
        </div>
        <div className="cw-row cw-sub-plan">
          <div className="cw-stack">
            {widget.title && (
              <span className="cw-h cw-sub-name">{widget.title}</span>
            )}
            {widget.subtitle && (
              <span className="cw-muted cw-sm">{widget.subtitle}</span>
            )}
          </div>
          <div className="cw-stack cw-sub-price">
            <span className="cw-sub-amount cw-num">{widget.price}</span>
            {widget.interval && (
              <span className="cw-muted cw-sm">{widget.interval}</span>
            )}
          </div>
        </div>
        {widget.meters && widget.meters.length > 0 && (
          <div className="cw-sub-meters">
            {widget.meters.map((meter, index) => (
              <Meter key={index} {...meter} text={text} />
            ))}
          </div>
        )}
        {dateRow && (
          <div className="cw-row cw-sm cw-muted cw-sub-date">
            <span>{dateRow.label}</span>
            <span className="cw-num cw-sub-date-value">{dateRow.value}</span>
          </div>
        )}
      </div>
      <LinkFoot url={widget.url}>
        {widget.urlLabel || text("widgetManageBilling")}
        <ArrowUpRightIcon size={15} />
      </LinkFoot>
    </Card>
  );
};
